import { useState, useEffect, Fragment } from 'react';
import useMedia from "../js/useMedia"
import {useWindowScroll} from 'react-use'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom';
import LangSet from '../LANG/LangSet.jsx'


//import Loader from "./Loader"
import './shapka.css'


import {
    Link,
    NavLink
} from "react-router-dom";

export default function LoginMenu(){
    const location = useLocation();

    const topnav = useSelector(state => state.site.topnav);
    const setup = useSelector(state => state.site.setup);

    // Явно проверяем, что язык валиден, иначе используем 'ru' по умолчанию
    let LANG = ['ru', 'en', 'de'].includes(setup.lang) ? setup.lang : 'ru';

    let [isMenu, setMenu] = useState(false)
    let [logoClass, setLogoClass] = useState('logo z10');

    let small = useMedia("(max-width:650px)");
    let large = useMedia("(min-width:650px)");
    const {x, y} = useWindowScroll();

    var path ='';
    // Extract path without language prefix for comparison with menu item IDs
    // pathname like "/ru/signup" → split: ["", "ru", "signup"] → slice(2): ["signup"]
    const ltmp = location.pathname.replace(/\/+$/, '').split('/').slice(2).join('/');

    useEffect(() => {
        if( y>5 ) {setLogoClass('logo z6')} else {setLogoClass('logo z10')}
    }, [y] );

const toggleMenu =() => isMenu ? setMenu(false) : setMenu(true);

const punkts = (cls) => {
  return <Fragment>
            <ul className={cls} onClick={small? toggleMenu : null}>
            {
                topnav.map((i, key) => {
                    const isActive = (i.id === 'home' && ltmp === '') || (i.id !== 'home' && i.id === ltmp);
                    return <li key={key}>
                        <Link to={path = i.id === 'home' ? '/' + LANG : '/' + LANG + '/' + i.id} className={isActive ? 'active':''}>
                            {i.ttl}
                        </Link>
                    </li>
                })
            }
            {
                large? null : <li><LangSet active={LANG}/></li>
            }
            </ul>
            {
                large? <LangSet active={LANG}/> : null
            }
        </Fragment>
      }
      
return(
    <Fragment>
        {
            large ? <Fragment>
            <div className="NavPenel sticky">
                {
                  punkts('App-header')
                }
                {
                    //<LangSet active={setup.lang}/>
                }
            </div> 
            
            </Fragment>
            : 
            <div key="nav">
                <img src={setup.domen + setup.folder + '/svg/menu.svg'} className="m-top-menu" onClick={toggleMenu} alt="menu"/>
                        {
                        isMenu ? 
                            punkts('Mob-header')
                        :null
                        }
            </div>
        }
        {small? isMenu ? <div key="overlay" className="overlay" onClick={toggleMenu}/>:null:null}
    </Fragment>
)

}